import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["skeleton", "image", "content", "textSkeleton"]

  connect() {
    if (!this.hasImageTarget) {
      this.showContent()
      return
    }

    // Check if image is already loaded or cached
    if (this.imageTarget.complete && this.imageTarget.src) {
      this.imageLoaded()
    } else {
      // For images that need to load or when src changes
      this.imageTarget.addEventListener("load", this.imageLoaded.bind(this))
      this.imageTarget.addEventListener("error", this.imageError.bind(this))
    }
  }

  disconnect() {
    // Clean up event listeners
    if (this.hasImageTarget) {
      this.imageTarget.removeEventListener("load", this.imageLoaded.bind(this))
      this.imageTarget.removeEventListener("error", this.imageError.bind(this))
    }
  }

  imageLoaded() {
    // Fade in image
    this.imageTarget.classList.remove("opacity-0")
    
    // Hide skeleton
    this.skeletonTarget.classList.add("opacity-0")
    
    // Show content
    this.showContent()

    // Remove skeleton after animation
    setTimeout(() => {
      this.skeletonTarget.classList.add("hidden")
    }, 300)
  }

  imageError() {
    // On error, show a failed state but still remove loading
    this.skeletonTarget.classList.remove("animate-pulse")
    this.showContent()
  }

  showContent() {
    if (this.hasContentTarget) {
      this.contentTarget.classList.remove("opacity-0")
    }
    if (this.hasTextSkeletonTarget) {
      this.textSkeletonTarget.classList.add("hidden")
    }
  }
} 